/**
 * @module URL失効確認表示用コンポーネント
 */
export default {
  name: 'ExpiredUrlConfirmation',
  data() {
    return {};
  },
  /** @type {Methods} */
  methods: {
    /**
     * 画面遷移処理
     * @param {String} url 遷移先画面パス
     */
    replace(url) {
      if (url) {
        this.$router.replace({
          path: url,
        });
      }
    },
  },
};
